import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  Card: {
    display: 'flex',
    height: '100%',
    maxHeight: 'fit-content',
    width: '100%',
    padding: '16px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    borderRadius: '12px',
    border: '1px solid var(--Gray-200, #EAECF0)',
    background: 'var(--Base-White, #FFF)',
    boxShadow: '0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)',
  },
  BoxContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  BoxAmount: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  BoxInformation: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    justifyContent: 'space-between',
  },
  BoxHeaderContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
  },
  BoxTime: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
  },
  BoxCreatedTime: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  BoxSeat: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    width: '100%',
  },
  BoxId: {
    display: 'flex',
    padding: '2px 8px',
    alignItems: 'center',
    gap: '4px',
    borderRadius: '16px',
    background: 'var(--Gray-100, #F2F4F7)',
  },
  BoxStatusItem: {
    display: 'flex',
    padding: '2px 8px',
    alignItems: 'flex-start',
    borderRadius: '16px',
  },
  BoxEmpty: {
    width: '100%',
    height: '42px',
  },
}));

const buttonStyle = {
  display: 'flex',
  padding: '10px 16px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  borderRadius: '8px',
  border: '1px solid var(--Primary-50, #F2FBF3)',
  background: 'var(--Primary-50, #F2FBF3) !important',
};

const textButton = {
  fontSize: '14px',
  fontWeight: '600',
  lineHeight: '20px',
  color: 'var(--Primary-700, #296C32)',
};

export { buttonStyle, textButton, useStyles };

